import { ActiveRecord } from '@mysidewalk/active-record';
/**
 */
class PasswordResetExchange extends ActiveRecord {
}
PasswordResetExchange.$AR = {
    url: '',
    options: {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    },
};
export default PasswordResetExchange;
